import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import CustomerBusinessDetailsForm from "./form";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride



const base_url = customerservice.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Business Details page, where you can manage Customer's business details.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific business detail by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new business detail.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each business detail from this dropdown.",
    placement: "left",
  },
];

const BusinessDetailsTable = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();


  const customerId= localStorage.getItem("CustomerId")
  const customerstatus= parseInt(localStorage.getItem("Status"))
  const showButton = customerstatus === 1 ||customerstatus === 0 || localStorage.getItem("Status") === null;

  const actions = {
    entity: "Business Details",
    isSubright:true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: showButton,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: showButton,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: 
      [
        "UpdateDate", 
        "CreateDate",
        "VerifiedBy",
        "VerifiedDate",
        "LandMark",
        "HaveALocalAuthority",
      ],
      objectName: "customerBusinessDetailsById",
      parameters:{customerId:parseInt(customerId)},
      inputObjectName:"customerBusinessDetails"
    },


  };

  return (
    <Box m="20px">
         <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Customers
          </Button>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
            Start Page Tour
        </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="Business Details"
        subtitle="Manage Business Details"
        FormComponent={CustomerBusinessDetailsForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default BusinessDetailsTable;
